import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const UserAssign = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M21.854 7.146a.5.5 0 0 0-.708 0L17 11.293V8.5a.5.5 0 1 0-1 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 1 0 0-1h-2.793l4.147-4.146a.5.5 0 0 0 0-.708ZM11.5 13C7.463 13 5 14.15 5 18v1h13v-1c0-3.85-2.463-5-6.5-5ZM6 18c0-3.61 3.245-4 5.5-4s5.5.39 5.5 4H6ZM11.5 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-6C12.878 6 14 7.122 14 8.5S12.878 11 11.5 11 9 9.878 9 8.5 10.122 6 11.5 6Z" />
  </SvgIcon>
);

export default UserAssign;
